<template>
  <div>
    <!-- 筛选 -->
	<div class="wrapHeader">
		<my-search
		  timeScreen
		  :inputArr="inputArr"
		  :searchParams="searchParams"
		  :[dynamicData]="2"
		  @searchEvent="searchEvent"
		/>
		<el-button type="primary" size="small" @click="tradPush">批量推送</el-button>
	</div>
   
	
    <!--列表-->
    <my-table
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
	  @handleSelectionChange="handleSelectionChange"
    />

    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
    <!-- 详情组件 -->
    <my-dialog-detail
      :isDialogDetailShow.sync="isDialogDetailShow"
      :closeDialog="closeDialog"
    >
		<template>
			<div v-html="transHtml" v-loading='transHtmlLoading' class="articleDetails"></div>
		</template>
	</my-dialog-detail>
  </div>
</template>

<script>
import mixins from "@/mixins/common";
import {
  officialTweetList,
  ywDetails,
  messagePush
} from "@/network/mochaItom/index.js";
export default {
  mixins: [mixins],
  watch: {
    tableData: {
      handler(val) {},
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
		//筛选时文本框所需参数
		inputArr: [
		  {
		    name: "userZh",
		    defaultText: "请输入文档名称",
		  },
		],
		//搜索参数
		searchParams: {
		  timeOptions: "",
		  userZh: "",
		},
      tableHeader: [
        {
          name: "文档名称",
          prop: "docTitle",
          width: "150px",
        },
        {
          name: "标签",
          prop: "docTags",
          width: "150px",
        },
        {
          name: "来源单位",
          prop: "createUnit",
        },
        {
          name: "文档简介",
          prop: "docIntroduction",
        },
        {
          name: "发布时间",
          prop: "startTime",
        },
        {
          name: "操作",
          prop: "operation",
          operation: [
            { name: "详情", clickFun: this.detailArtice, show: true },
			{ name: "推送", clickFun: this.push, show: true },
          ],
        },
      ],
	 selectionData:[],//批量推送选择的数据
	 userCollection:null ,//是否可以推送
	 transHtml:"" ,//文章详情
	 transHtmlLoading:false,
    };
  },
  mounted() {
   
  },
  methods: {
    getInitData(isSearch) { //基础表格数据
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let params = {
        docTitle: this.searchParams.userZh,
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      officialTweetList(params).then((e) => {
        this.loading = false;
        let { code, data, msg } = e.data;
        if (code == 200) {
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1; this.userCollection = data.records[0].userCollection;
        }
      });
    },
	getArticleDetail(detailId) { //文章详情
		this.transHtmlLoading = true;
		ywDetails({
			docId: detailId,
		}).then(res => {
			if (res.data.code == 200) {
				var data = res.data.data
				if (!data.transHtml && !data.transMd) {
					this.$message('暂无数据');
				}
				this.transHtml = data.transHtml;
				this.transHtmlLoading = false;
			}
		}).catch(err => {
	
		})
	},
	detailArtice(item){//点击详情按钮出发的事件
		this.getArticleDetail(item.id)
		this.isDialogDetailShow = true;
	},
	handleSelectionChange(val){ //多选
		this.selectionData = val;
	},
	push(item){ //推送
		let id = item.id;
		this.getmessagePush([id])
	},
	tradPush(){ //批量推送
		if(this.selectionData.length==0){
			this.$message({
				type: 'info',
				message: '您还没有选择要推送的文章！'
			});      
			return
		}
		let docIds = this.selectionData.map(res=>{
			return res.id
		})
		this.getmessagePush(docIds);
	},
	getmessagePush(docIds){
		if(!this.userCollection){
			this.$message({
				type: 'info',
				message: '每天只能推送一次呦！'
			});
			return
		}
		this.$confirm('此操作将推送该文章, 是否继续?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning'
		}).then(res=> {
			messagePush({docIds:docIds}).then(res=>{
				if (res.data.code == 200) {
				  this.selectionData = false;
				  this.$message({
				  	type: 'success',
				  	message: '推送成功!'
				  });
				}else{
					this.$message({
						type: 'error',
						message: res.data.msg
					});
				}
				
			})
		}).catch(() => {
		  this.$message({
			type: 'info',
			message: '已取消推送'
		  });          
		});
	},
	closeDialog(){
		this.isDialogDetailShow = false;
	},
	//搜索事件
	searchEvent() {
	  this.getInitData(true);
	},
  },
};
</script>

<style  scoped lang="scss">
	.wrapHeader{
		height: auto;
		/deep/ .my-search{
			float: left;
		}
		.el-button{
			float: right;
			margin-top: 8px;
		}
	}
	.articleDetails{
		height: 60vh;
		overflow-y: auto;
		overflow-x: hidden;
		/deep/ div,/deep/ p{
			width: 100% !important;
		}
		/deep/img{
			width: 860px;
			margin: 20px 0;
		}
		
	}
	::-webkit-scrollbar {
		width: 0 !important;
	}
	
	::-webkit-scrollbar {
		width: 0 !important;
		height: 0;
	}
</style>

 
 